import { render, staticRenderFns } from "./battleBox.vue?vue&type=template&id=4abb37b6&scoped=true&"
import script from "./battleBox.vue?vue&type=script&lang=js&"
export * from "./battleBox.vue?vue&type=script&lang=js&"
import style0 from "./battleBox.vue?vue&type=style&index=0&id=4abb37b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abb37b6",
  null
  
)

export default component.exports